var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarcode({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "9.2656 -65.4414 75.8535 60.1797",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.76562-5.76172L16.0645-5.76172L16.0645-64.9414L9.76562-64.9414ZM22.1191-5.76172L25.7324-5.76172L25.7324-64.9414L22.1191-64.9414ZM31.7383-5.76172L41.9922-5.76172L41.9922-64.9414L31.7383-64.9414ZM45.752-5.76172L52.2949-5.76172L52.2949-64.9414L45.752-64.9414ZM56.2012-5.76172L66.3574-5.76172L66.3574-64.9414L56.2012-64.9414ZM69.4824-5.76172L77.4414-5.76172L77.4414-64.9414L69.4824-64.9414ZM79.4434-5.76172L84.6191-5.76172L84.6191-64.9414L79.4434-64.9414Z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcode);
export default __webpack_public_path__ + "static/media/barcode.243bd68c052b21778f94644aeb6fd9ea.svg";
export { ForwardRef as ReactComponent };